var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1274,
    height: 797,
    viewBox: "0 0 1274 797",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1204.59 268.096C1186.63 232.502 1165.65 202.79 1142.18 181.454C1135.52 175.321 1128.36 169.756 1120.77 164.817C1113.98 160.388 1106.8 156.588 1099.32 153.466C992.323 109.254 882.781 209.859 760.393 197.978C657.805 187.992 583.98 131.005 518.543 83.1644C495.419 66.229 473.309 50.42 451.314 38.2972C445.118 34.8476 438.893 31.7022 432.708 28.9059C426.056 25.9378 418.98 23.1444 411.429 20.5875C411.429 20.5725 411.423 20.5582 411.413 20.5476C411.402 20.5371 411.388 20.5311 411.373 20.5311L411.311 20.5875C316.508 -11.9119 156.384 -10.732 85.409 59.2172C11.1109 132.489 -79.1177 369.956 125.235 675.826C352.29 1015.8 972.652 1062.81 1138.42 950.385C1309.97 834.135 1303.07 463.427 1204.59 268.096Z",
    fill: "#F9FBFF",
    fillOpacity: 0.8
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg2.586404f4210dd1f3077747c6569d6279.svg";
export { ForwardRef as ReactComponent };